import { Chains, chainsList, chainsMap } from '#/config/constants';

// TODO: circular - update imports from config/constants in cases when this file can not be imported (reduce cyclic deps)
export type { Chains as Chains };
export { chainsMap, chainsList };

// export const CHAIN_LOCAL_STORAGE_ID = 'katana_chain';

export const getChainNativeAssetTitle = (
  chain: Chains
): (typeof chainsMap)[Chains]['title'] => {
  return chainsMap[chain]?.title || chainsMap.katanaEVMChain.title;
};

// export const getStaticChainWithUrlExceptions = (
//   _pathname?: string,
//   _locationSearch?: string
// ): 'katanaEVMChain' => {
//   // Note: This is how we handled legacy chain
//   // if (isPageOrUnlockReturn('/wallet/history/old-balances/v2/eth')) {
//   //   return 'ethereumChain';
//   // }
//   return 'katanaEVMChain';
// };

const listedChainCodes: Chains[] = chainsList.map(chain => chain.code);

// TODO: katana remove multi-chain concept
/** @deprecated Inanctive chains will not subscribe to websocket, or use notifications */
export const isChainListed = (chain: Chains) =>
  listedChainCodes.includes(chain);

/**
 * Check whenever provided symbol is native asset (eg. POL, ETH, etc)
 *
 * For checking native symbol in components use "useSelectorActiveChain" hook instead
 */
// export const isNativeAssetSymbol = (symbol: string, activeChain: Chains) => {
//   return getChainNativeAssetSymbol(activeChain) === symbol;
// };

// export const isNativeAssetAddress = (address: string) => {
//   return address === ZeroAddress;
// };
